SparkleVersion = '3.30.0.3';